import { BasicQueryStringUtils } from '@openid/appauth/built/query_string_utils';
import { LocationLike , StringMap } from '@openid/appauth/built/types';

export class NoHashQueryStringUtils extends BasicQueryStringUtils {
  parse(input: LocationLike, useHash?: boolean): StringMap {
    return super.parse(input, false /* never use hash */);
  }
}
